module.exports = __webpack_public_path__ + "img/excedrin_pm.c5a3fc84.png";